import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './AlbumDesignTermsModal.css';
import { useUser } from '../../context/UserProvider';

const AlbumDesignTermsModal = ({ isOpen, onClose, onAcknowledge }) => {
    const [isChecked, setIsChecked] = useState(false);
    const navigate = useNavigate();
    const {mongoUser, cognitoUser} = useUser()

    if (!isOpen) return null;

    const handleConfirm = () => {
        if (!isChecked) return;

        const acknowledgmentData = {
            acknowledged: true,
            date: new Date(),
            firstName: mongoUser?.firstName,
            lastName: mongoUser?.lastName ,
            _id: mongoUser?._id
        };

        onAcknowledge(acknowledgmentData);
        onClose();
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <h2>Acknowledgment</h2>
                <p>
                    "I have read and understood the <a href='/terms-and-conditions/album-design' target="_blank" rel="noopener noreferrer">Terms and Conditions</a> regarding the album design services, image usage and copyright release, including the no-revision policy unless I purchase a revision package."
                </p>
                <label className="checkbox-label">
                    <input 
                        type="checkbox" 
                        checked={isChecked} 
                        onChange={() => setIsChecked(!isChecked)} 
                    />
                    I acknowledge and agree to the terms.
                </label>
                <div className="modal-actions">
                    <button onClick={onClose} className="cancel-button">Cancel</button>
                    <button onClick={handleConfirm} className="confirm-button" disabled={!isChecked}>Confirm</button>
                </div>
            </div>
        </div>
    );
};

export default AlbumDesignTermsModal;